export const CLocalStorage = {
    Keys: {
        Token: "sso-token",
        Email: "sso-email",
        RememberMe: "sso-rememberme"
    }
}

export const CTargetResource = {
    LOADING: "LOADING",
    SUCCESS: "SUCCESS",
    FAILED: "FAILED"
}